import {Component, OnInit, Output, EventEmitter, OnDestroy} from '@angular/core'
import {FormBuilder, FormGroup, Validators} from '@angular/forms'

import {Observable, BehaviorSubject, Subject} from 'rxjs'
import {finalize, switchMap, tap, map, takeUntil} from 'rxjs/operators'

import {Contract, ContractType} from '@app/core/services/rest-api'
import {ContractManagerService} from '@app/core/services/contract/contract-manager.service'
import {ContractService} from '@app/core/services/contract/contract.service'
import {ContextService} from '@app/core/services/context.service'
import {LoggerService} from '@app/core/services/logger.service'

import {FormBasedComponent} from '@app/features/base/form-based.component'
import {BsModalRef} from 'ngx-bootstrap/modal'
import {OptionSelectEntry} from '../option-select/option-select.component'

@Component({
  templateUrl: './contract-selector-new-modal.component.html',
  providers: [ContractManagerService],
  standalone: false,
})
export class ContractSelectorNewModalComponent
  extends FormBasedComponent
  implements OnInit, OnDestroy
{
  loading$: BehaviorSubject<boolean> = new BehaviorSubject(false)
  availableTypes$: Observable<ContractType[]>
  initialCode: string = this.context.activeDomain
  availableTypesAsOptions$ = new BehaviorSubject<OptionSelectEntry[]>([])
  destroy$ = new Subject<boolean>()

  @Output()
  onClose: EventEmitter<Contract> = new EventEmitter<Contract>()

  constructor(
    protected fb: FormBuilder,
    private manager: ContractManagerService,
    private contractSvc: ContractService,
    private context: ContextService,
    private bsModalRef: BsModalRef,
    private logger: LoggerService,
  ) {
    super(fb)
  }
  ngOnDestroy(): void {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  ngOnInit() {
    this.initForm()

    /* On domain changes load the new list of contract types, and return types as an observable */
    // this.availableTypes$ = this.form.get('domain').valueChanges
    //   .pipe(
    //     switchMap((code) => {
    //       this.loading$.next(true);
    //       return this.contractSvc.getContractTypes(code)
    //         .pipe(
    //           map((contractTypes) => {
    //             contractTypes.sort((a, b) => {
    //               if (a.name > b.name) { return 1; }
    //               if (a.name < b.name) { return -1; }
    //               return 0;
    //             });
    //             return contractTypes;
    //           }),
    //           tap((contractTypes)=>{
    //             this.availableTypesAsOptions$.next(contractTypes.map((e)=> {return {value: e, label: e.name}}))
    //           }),
    //           finalize(() => this.loading$.next(false))
    //         )
    //     })
    //   );

    this.form
      .get('domain')
      .valueChanges.pipe(
        takeUntil(this.destroy$),
        switchMap((code) => {
          this.loading$.next(true)
          return this.contractSvc.getContractTypes(code).pipe(
            map((contractTypes) => {
              contractTypes.sort((a, b) => {
                if (a.name > b.name) {
                  return 1
                }
                if (a.name < b.name) {
                  return -1
                }
                return 0
              })
              return contractTypes
            }),
            tap((contractTypes) => {
              this.availableTypesAsOptions$.next(
                contractTypes.map((e) => {
                  return {value: e, label: e.name}
                }),
              )
            }),
            finalize(() => this.loading$.next(false)),
          )
        }),
      )
      .subscribe()
  }

  buildForm(fb: FormBuilder): FormGroup {
    return fb.group({
      domain: fb.control(this.initialCode, Validators.required),
      contractType: fb.control(null, Validators.required),
    })
  }

  get domain() {
    return this.form.get('domain')
  }
  get contractType() {
    return this.form.get('contractType')
  }

  processSubmit(form: FormGroup): Observable<any> {
    let selectedType: ContractType = (
      this.form.get('contractType').value as OptionSelectEntry
    ).value

    const contract: Contract = {
      name: this.form.get('domain').value + ' - ' + selectedType.code,
      type: selectedType,
      domain: this.form.get('domain').value,
    }

    this.manager.domain = this.form.get('domain').value

    return this.manager.create(contract).pipe(
      tap(
        (contract) => {
          this.onClose.emit(contract)
          this.closeModal()
        },
        (err) => {
          this.form.setErrors({global: 'Error during creation: ' + err.message})
        },
      ),
    )
  }

  get defaults() {
    return {
      domain: this.initialCode,
      type: null,
    }
  }

  closeModal() {
    this.bsModalRef.hide()
  }
}
